export const wrapperTestId = "positionsWrapper";

